<b>Vehicle Utilisation</b>
<hr>
<ngx-charts-line-chart
  [view]="view"
  [scheme]="colorScheme"
  [legend]="showLegendPie"
  [showXAxisLabel]="showXAxis"
  [showYAxisLabel]="showYAxis"
  [xAxis]="showXAxis"
  [yAxis]="showYAxis"
  [xAxisLabel]="xAxisLabel"
  [yAxisLabel]="yAxisLabel"
  [timeline]="timeline"
  [results]="dataLine"
  >
</ngx-charts-line-chart>
